import React, {useState} from 'react';
import {Link} from "react-router-dom";

const DownloadButton = (props) => {

	const {link, disabled} = props;

	const [downloading, setDownloading] = useState(false);
	const [showDownloadIcon, setShowDownloadIcon] = useState(props.showDownloadIcon ?? false);
	const [showSpinner, setShowSpinner] = useState(props.showSpinner ?? false);
	const handleDownload = async () => {
		setDownloading(true);

		try {
			// Make the AJAX request using fetch or axios
			const response = await fetch(link, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/octet-stream',
				},
			});

			if (!response.ok) {
				throw new Error('Failed to fetch the file');
			}

			const disposition = response.headers.get('Content-Disposition');
			let filename = 'consumption_report.pdf'; // Default filename

			if (disposition && disposition.includes('filename=')) {
				const filenameMatch = disposition.match(/filename="?([^"]+)"?/);
				if (filenameMatch.length > 1) {
					filename = filenameMatch[1];
				}
			}

			// Get the file data as a blob
			const blob = await response.blob();

			// Create a URL for the blob and trigger a download
			const downloadUrl = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = downloadUrl;
			a.download = filename; // Set the file name here
			document.body.appendChild(a);
			a.click();

			// Clean up the URL object
			a.remove();
			window.URL.revokeObjectURL(downloadUrl);

			if (props.closeModal) {
				setTimeout(()=>{
					props.closeModal();
				}, 1000)
			}
		} catch (error) {
			console.error('Error downloading the file:', error);
		}
	};

	return (
		<Link
			className={`btn btn--raised btn--raised--red ${disabled || downloading ? 'disabled' : ''}`}
			onClick={handleDownload}>
			{props.children}&nbsp;
			{
				!downloading ?
					(showDownloadIcon ? (props.downloadIcon ?? <i className="fas fa-download d-inline-block "></i>) : null) :
					(showSpinner ? (props.loadingIcon ?? <i className="fas fa-circle-notch fa-spin d-inline-block "></i>) : null)
			}
		</Link>
	);
};

export default DownloadButton;
